export enum LeadKindEnum {
  SELLER = "consultant",
  AMBASSADOR = "ambassador",
  LEAD_GENERATOR = "lead_generator",
}
